<template>
	<div id="noticebox">
		<div class="notice_main">
			<div class="crumbs">
				<span style="color: #BDBDBD;">
					<a><router-link to="/"style="text-decoration: none;color: #BDBDBD;">首页</router-link></a>
					 > 
					<a><router-link to="/announcementPage"style="text-decoration: none;color: #BDBDBD;">公告中心</router-link></a>
					 > 
					<a style="text-decoration: none;color: #076bf2;" href="#">公告详情</a>
				</span>
			</div>
			<div class="notice_main_in">
				<h2  class="notice_header">{{title}}</h2>
				<hr style="margin-left: 20px;width: 95%;" />
				<!-- 显示内容 -->
				<!--<iframe v-if="contentShow" frameborder="no" v-bind:src="'http://39.104.14.210/dataGalaxy'+content" style="width: 100%;height: 100%;"></iframe>-->
				<div id="notice_rdt" v-html="notice_rdt">
					
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				notice_rdt:``,// 公告富文本内容
				uuid:'',
				title:'',
				content:'',
				contentShow:0,			//是否显示内容
			}
		},
		mounted(){
			this.uuid = this.$route.query.uuid;
			let _this=this;
			//获取数据
			this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=notice_details',
				{
					params: {  
						"contentCode":this.uuid
					}  
				}
			).then(response => {
				
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
//					alert('请求错误');
					return;
				}
				
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					
					//显示空数据页面
//					alert('没有数据');
					return;
				}
				
				this.title = response.body.data.title;
				this.content = response.body.data.content;
				
				this.contentShow = 1;
				this.notice_rdt=this.content;
			}, response => {
//				console.log("error");
			});
		},
	}
</script>

<style>
	#noticebox{
		min-height: 100%;
		background-color: #F3F3F3;
		/*padding-bottom: 30px;*/
	}
	.notice_header {
		margin-top: 20px;
		width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #222222;
		font-size: 18px;
	}
	
	.crumbs {
		width: 100%;
		height: 50px;
		background-color: #F3F3F3;
		line-height: 50px;
		text-align: left;
		text-decoration: none;
	}
	
	.notice_main {
		width: 1200px;
		min-height:calc(100% - 40px);
		margin: 0 auto;
		background: white;
	}
	
	.notice_main_in {
		width: 100%;
		min-height: 100% - 50px;
		padding-bottom: 50px;
		background-color: #FFFFFF;
	}
	#notice_rdt{
		width: 92%;
		margin: 0 auto;
		text-align: left;
		margin-top: 20px;
	}
	#notice_rdt>p{
		font-size: 16px;
		line-height: 1.5;
	}
	#notice_rdt>p img{
		max-width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/views/noticePage.vue